import {
  getFontCss,
  HoverableLinkSizes,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { Fragment } from 'react'
import ActiveUntilTooltip from 'src/components/ActiveUntilTooltip/ActiveUntilTooltip'
import Box from 'src/components/Box/Box'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface ActiveUntilBoxProps {
  className?: string
  inactiveSinceString?: string
  activeUntilString?: string
  openLeftMdUp: boolean
  openLeftSmDown: boolean
  pendingRecurringTo?: string
  consumedOrClosed?: boolean
  isAccountClosed?: boolean
}

const ActiveUntilBox: React.FC<ActiveUntilBoxProps> = (
  props,
): React.ReactElement => {
  return (
    <Box
      css={css`
        display: flex;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: flex-end;
          flex-grow: 2;
        `}
      >
        {props.inactiveSinceString === undefined && (
          <Fragment>
            <span
              css={css`
                white-space: nowrap;
                margin-right: 12px;
                ${getFontCss(
                  20,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.regular,
                )};
              `}
            >
              <Trns source={'Active Until'} />
            </span>
            {props.pendingRecurringTo === undefined && (
              <span
                css={css`
                  ${getFontCss(
                    20,
                    themeConstants.colors.highlight,
                    styleConstants.fontFamilies.regular,
                  )};
                `}
                data-testid={'activeUntilDate'}
              >
                {props.activeUntilString || <Trns source={'Never Ends'} />}
              </span>
            )}
            {props.pendingRecurringTo !== undefined && (
              <HoverableLink
                to={props.pendingRecurringTo}
                underline
                size={HoverableLinkSizes.Large}
                regular
                ariaLabelSource={'See Request Details'}
              >
                <Trns source={'See Request Details'} />
              </HoverableLink>
            )}
          </Fragment>
        )}
        {props.inactiveSinceString !== undefined && (
          <span
            css={css`
              ${getFontCss(
                20,
                styleConstants.colors.red,
                styleConstants.fontFamilies.regular,
              )};
            `}
            data-testid={
              props.consumedOrClosed ? 'closedSinceDate' : 'inactiveSinceDate'
            }
          >
            {(props.consumedOrClosed || props.isAccountClosed) && (
              <Trns
                source={'Closed since ${date}'}
                expressions={{
                  date: props.inactiveSinceString,
                }}
              />
            )}
            {!(props.consumedOrClosed || props.isAccountClosed) && (
              <Trns
                source={'Inactive since ${date}'}
                expressions={{
                  date: props.inactiveSinceString,
                }}
              />
            )}
          </span>
        )}
      </div>
      <Fragment>
        <ActiveUntilTooltip
          hideSmDown
          isConsumedOrClosed={props.consumedOrClosed}
          isInactive={props.inactiveSinceString !== undefined}
          openLeft={props.openLeftMdUp}
          isAccountClosed={props.isAccountClosed}
        />
        <ActiveUntilTooltip
          hideMdUp
          isConsumedOrClosed={props.consumedOrClosed}
          isInactive={props.inactiveSinceString !== undefined}
          openLeft={props.openLeftSmDown}
          isAccountClosed={props.isAccountClosed}
        />
      </Fragment>
    </Box>
  )
}

export default ActiveUntilBox
